"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;

var _Label = _interopRequireDefault(require("./Label"));

exports.default = _Label.default;